import { render, staticRenderFns } from "./CrmList.vue?vue&type=template&id=213181d7"
import script from "./CrmList.vue?vue&type=script&lang=js"
export * from "./CrmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports